




























































































import { computed, defineComponent, onMounted, PropType, ref } from "@vue/composition-api";
import { InputMaskOptions } from "@/modules/inputMask";
import { INPUT_PROPS } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseInputBox from "@/components/BaseInputBox";
import ValidationProvider from "@/components/ValidationProvider";

export default defineComponent({
  name: "BaseInput",
  components: { BaseIcon, ValidationProvider, BaseInputBox },
  props: {
    ...INPUT_PROPS,
    maskOpts: { type: Object as PropType<InputMaskOptions> },
    autofocus: { type: Boolean, default: false },
    fieldClass: {
      type: [String, Object, Array] as PropType<
        string | Record<string, boolean> | (string | Record<string, boolean>)[]
      >,
    },
  },
  setup(props, { slots, emit }) {
    const inputElement = ref<HTMLInputElement>();

    const hasPrepend = computed(() => !!props.prependIcon || !!slots.prependIcon);
    const hasSecondAppend = computed(() => !!props.secondAppendIcon || !!slots.secondAppendIcon);
    const hasAppend = computed(() => !!props.appendIcon || !!slots.appendIcon);

    const input = (e: InputEvent) => {
      emit("input", (e.target as HTMLInputElement).value, e);
    };

    const onValidation = (...v: any[]) => {
      emit("validation", ...v);
    };

    onMounted(() => {
      if (props.autofocus) {
        inputElement.value?.focus();
      }
    });
    return {
      inputElement,
      hasPrepend,
      hasSecondAppend,
      hasAppend,
      input,
      onValidation,
    };
  },
});
